import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
// import ReactNotification from 'react-notifications-component';
import * as serviceWorker from './serviceWorker';
import Firebase, { FirebaseContext } from './firebase';
import { StripeProvider } from 'react-stripe-elements';
import 'react-notifications-component/dist/theme.css';

ReactDOM.render(
    <FirebaseContext.Provider value={new Firebase()}>
        {/* <ReactNotification /> */}
        <StripeProvider
            apiKey={
                process.env.REACT_APP_DEV === 'true'
                    ? 'pk_test_aTpwht0Ga9oecRLzno2f0u6000PKqilvAa'
                    : 'pk_live_rQMPK93V3ocXI77JK4N4CbzV00jY3KZuJY'
            }
        >
            <App />
        </StripeProvider>
    </FirebaseContext.Provider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
